<script setup>
import { ref, computed, inject, onUnmounted, watch} from 'vue'
import { debounce } from 'lodash-es'
import { useWorkspaceStore } from '@stores/WorkspaceData';
const wpStore = useWorkspaceStore()
import { planService } from '@requests/Main/plan.service';
import { unixToDate, dateToUnix } from '@services/process/Main/unix.servise';
import DatePicker from 'primevue/datepicker';
import Select from 'primevue/select';
import Fieldset from 'primevue/fieldset';
const toast = inject('toast')

const Tar = computed(() => wpStore.experiment.Tar)
const Plan = computed(() => wpStore.experiment.Plan)
const ShootingTime = computed(() => Plan.value?.shootingTime || null)
// Буфер для поля «Начало съёмки», чтобы DatePicker не откатывал значение до ответа сервера
const shootingStartInput = ref(null)
watch(() => ShootingTime.value?.shootingStart, (v) => { shootingStartInput.value = unixToDate(v) }, {immediate: true})

const modellingVisibility = ref(false)
const ModellingVisibility = async () => {
  toast.info("Начинаем расчёт времени съёмки")
  modellingVisibility.value = true
  const result = await planService.CalculateShootingTime(Plan.value)
  await planService.Reload()
  modellingVisibility.value = false
  if(!result){
    toast.error("Не удалось провести расчёт")
    return
  }
  // Сервер отвечает 200 с пустым временем съёмки, если за горизонт цель не видна
  if(!result.points?.length){
    toast.warn("За горизонт моделирования цель не видна — время съёмки не определено")
    return
  }
  toast.success(`Расчёт времени съёмки успешен`)
}

// Начало съёмки выбирает пользователь только в режиме PHOTO_AGILE, окончание считает сервер.
// Каждый щелчок по часам/минутам меняет значение — отправляем последнее после паузы
const ChangeShootingStart = debounce(async (date) => {
  if(!date) return
  const result = await planService.PutShootingTime(Plan.value, dateToUnix(date))
  await planService.Reload()
  if(!result){
    toast.warn('Крен, тангаж для выбранного времени не определены')
  }
}, 500)
onUnmounted(() => ChangeShootingStart.flush())

const shootingMode = [{label: "Фотосъемка не манёвренная", value:'PHOTO_NON_AGILE'},{label: "Фотосъемка манёвренная", value:'PHOTO_AGILE'},{label: "Видеосъемка", value:'VIDEO'},{label: "Маршрутная съемка", value:'ROUTE'}]
</script>

<template>

<section v-if="Tar" class="SectionPanel">

<Fieldset legend="Время съёмки">
    <div class="fieldsetDiv">
      <FloatLabel variant="on">
        <Select v-model="Tar.shootingMode" :options="shootingMode" optionLabel="label" optionValue="value"/>
        <label>Тип съёмки</label>
      </FloatLabel>
    </div>
    <div>
      <Button label="Расчёт времени съёмки" raised @click="ModellingVisibility" :icon="`pi ${modellingVisibility?'pi-spin pi-spinner':'pi-refresh'}`" iconPos="right" :disabled="modellingVisibility || !Plan"/>
    </div>

    <template v-if="ShootingTime?.windowStart != null">
    <div class="fieldsetDiv">
      <FloatLabel variant="on">
        <DatePicker :modelValue="unixToDate(ShootingTime.windowStart)" showTime hourFormat="24" showSeconds dateFormat="dd.mm.yy" disabled style="width: 100%;"/>
        <label>Начало видимости</label>
      </FloatLabel>
    </div>
    <div class="fieldsetDiv">
      <FloatLabel variant="on">
        <DatePicker :modelValue="unixToDate(ShootingTime.windowEnd)" showTime hourFormat="24" showSeconds dateFormat="dd.mm.yy" disabled style="width: 100%;"/>
        <label>Окончание видимости</label>
      </FloatLabel>
    </div>
    <div class="fieldsetDiv">
      <FloatLabel variant="on">
        <DatePicker v-model="shootingStartInput" @update:modelValue="ChangeShootingStart"
          :minDate="unixToDate(ShootingTime.windowStart)" :maxDate="unixToDate(ShootingTime.windowEnd)"
          showTime hourFormat="24" showIcon showSeconds dateFormat="dd.mm.yy" :disabled="Tar.shootingMode !== 'PHOTO_AGILE'"/>
        <label>Начало съёмки</label>
      </FloatLabel>
    </div>
    <div class="fieldsetDiv">
      <FloatLabel variant="on">
        <DatePicker :modelValue="unixToDate(ShootingTime.shootingEnd)" showTime hourFormat="24" showIcon showSeconds dateFormat="dd.mm.yy" disabled/>
        <label>Окончание съёмки</label>
      </FloatLabel>
    </div>
    <div class="fieldsetDiv">
      <FloatLabel variant="on">
        <InputNumber :modelValue="ShootingTime.shootingRoll" :maxFractionDigits="5" size="small" style="width: 100%;" disabled/>
        <label>Крен</label>
      </FloatLabel>
    </div>
    <div class="fieldsetDiv">
      <FloatLabel variant="on">
        <InputNumber :modelValue="ShootingTime.shootingPitch" :maxFractionDigits="5" size="small" style="width: 100%;" disabled/>
        <label>Тангаж</label>
      </FloatLabel>
    </div>
    </template>

</Fieldset>
</section>
</template>

<style>

</style>
